import { useEffect } from 'react';
import ExpressStore from '@/stores/express';
import SkuStore from '@/stores/sku';

interface PropType {
  skuInfoMap: InventoryTypes.SkuInfoMap;
  skuAttrs: SkuTypes.SkuAttr[];
  skuInventoryMap: InventoryTypes.SkuInfoMap;
  type: SkuTypes.TypeInfo;
}
export default function Product(props: PropType) {
  const { skuInfoMap, skuInventoryMap, skuAttrs, type } = props;

  if (type !== 'product') return null;

  const skuStore = SkuStore((state) => state);
  const expressStore = ExpressStore((state) => state);
  const { dispatchId } = expressStore;


  useEffect(() => {
    if (dispatchId) {
      skuStore.setSkuInfo(type, skuAttrs, skuInventoryMap, skuInfoMap, dispatchId);
      skuStore.setSkuSelect(type);
      // 增加默认选中
      // skuStore.setSkuImageReview(type, attr[0].values[0]);
    }
  }, [dispatchId]);

  return null;
}
